import React from 'react';
import { FileTextIcon, SheetIcon, PrinterIcon, RefreshCwIcon } from 'lucide-react';
import { exportCSV, exportExcel, printResults } from '../../lib/exporters';
import type { Vote } from '../../lib/types';
export function ExportBar({
  votes,
  onRefresh
}: {
  votes: Vote[];
  onRefresh: () => void;
}) {
  return <div className="flex flex-wrap gap-2 print:hidden" data-id="element-30" data-mp="ku3f8jxi3kty">
      <Btn onClick={() => exportCSV(votes)} icon={<FileTextIcon className="h-4 w-4" data-id="element-32" data-mp="18k65cuhuugpx" />} data-id="element-31" data-mp="18iv4b2fsnn2i">
        📄 Export CSV
      </Btn>
      <Btn onClick={() => exportExcel(votes)} icon={<SheetIcon className="h-4 w-4" data-id="element-34" data-mp="1cjos7vt8l1ve" />} data-id="element-33" data-mp="1ckq05reyh88w">
        📊 Export Excel
      </Btn>
      <Btn onClick={printResults} icon={<PrinterIcon className="h-4 w-4" data-id="element-36" data-mp="yr8th77dbq0a" />} data-id="element-35" data-mp="ysa63g418kk4">
        📑 Print Results
      </Btn>
      <Btn onClick={onRefresh} icon={<RefreshCwIcon className="h-4 w-4" data-id="element-38" data-mp="1rhqw6746jpd6" />} data-id="element-37" data-mp="13qbp611gkjvl">
        Refresh
      </Btn>
    </div>;
}
function Btn({
  onClick,
  icon,
  children
}: {
  onClick: () => void;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return <button onClick={onClick} className="inline-flex items-center gap-2 rounded-2xl border-2 border-slate-200 bg-white px-4 py-2.5 text-sm font-600 text-slate-700 shadow-sm transition hover:border-lavender-300 hover:text-lavender-600" data-id="element-39" data-mp="2frgvi7fciqwa">
      {icon}
      {children}
    </button>;
}